// 顾客联系人管理
import {contractApi} from "@/axios";
//获取客户联系人信息
export function getUserPage(params,data){
    return contractApi({
        url:'/customerContacts/page',
        method:'post',
        data:data,
        params:params
    })
}
//添加客户联系人信息
export function addUser(data){
    return contractApi({
        url:'/customerContacts',
        method:'post',
        data:data
    })
}
//修改客户联系人信息
export function editUser(data){
    return contractApi({
        url:'/customerContacts',
        method:'put',
        data:data
    })
}
// 删除联系人信息
export function deletecus(params){
    return contractApi({
        url:'/customerContacts',
        method:'delete',
        params: params
    })
}
//获取销售相关客户联系人
export function getUserById(id){
    return contractApi({
        url:'/customerContacts/all-customer-contacts/' + id,
        method:'get'
    })
}
//获取联系人可扣款金额
export function getUserAmountById(params){
    return contractApi({
        url:'/customerContacts/get-remaining-deduction-amount',
        params:params,
        method:'get'
    })
}
//批量更改客户联系人销售
export function editUserSales(data){
    return contractApi({
        url:'/customerContacts/change-sales',
        method:'put',
        data:data
    })
}